import { formatDateTime } from "../../utils/dateUtils";

/** Map GET /users/me profile into Edit Profile form + header meta. */
export function mapMeToEditProfileState(me) {
  if (!me || typeof me !== "object") return null;
  const nameFromParts = [me.firstName, me.lastName].filter(Boolean).join(" ").trim();
  const displayName = nameFromParts || String(me.name ?? "").trim();
  return {
    formData: {
      name: displayName,
      email: me.email ?? "",
      phoneNumber: me.mobileNumber ?? me.phoneNumber ?? "",
      timezone: me.timezone ?? "UTC",
      emailNotifications: me.emailNotifications ?? true,
    },
    userMeta: {
      role: me.role?.name ?? "",
      team: me.team?.name ?? "",
      lastLogin: me.last_active_at ? formatDateTime(me.last_active_at, { emptyLabel: "—" }) : "—",
    },
  };
}
